function getAPI({ req }) {
    const BACKEND_URL = process.env.BACKEND_URL
  const API = `${BACKEND_URL}${req}`;
  return API;
}

export default getAPI;
